"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSwiper = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _swiper = require("swiper");
var _react2 = require("swiper/react");
var _DeviceCard = require("../Card/DeviceCard");
require("../../styles/components/SwiperWithVirtualMode.css");
var _selectors = require("../../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const cardSize = 233;
const spaceBetweenCards = 30;
const inaccuracyByWindowSize = {
  max1000: 0.1,
  max2000: 0.3,
  max3000: 0.35,
  max4000: 0.4,
  min4000: 0.5
};
const DeviceSwiper = () => {
  const filteredIdList = (0, _reactRedux.useSelector)(_selectors.selectFilteredIdList);
  const getInaccuracy = width => {
    if (width < 1000) return inaccuracyByWindowSize.max1000;
    if (width < 2000) return inaccuracyByWindowSize.max2000;
    if (width < 3000) return inaccuracyByWindowSize.max3000;
    if (width < 4000) return inaccuracyByWindowSize.max4000;
    return inaccuracyByWindowSize.min4000;
  };
  return /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    freeMode: true,
    modules: [_swiper.FreeMode, _swiper.Navigation, _swiper.Virtual],
    onAfterInit: swiper => {
      // eslint-disable-next-line no-param-reassign
      swiper.params.slidesPerView = swiper.width / (cardSize + spaceBetweenCards) - getInaccuracy(swiper.width);
    },
    onResize: swiper => {
      // eslint-disable-next-line no-param-reassign
      swiper.params.slidesPerView = swiper.width / (cardSize + spaceBetweenCards) - getInaccuracy(swiper.width);
    },
    spaceBetween: spaceBetweenCards,
    navigation: true,
    grabCursor: true,
    className: "SwiperWithVirtualMode",
    virtual: {
      addSlidesAfter: 5,
      addSlidesBefore: 5,
      cache: true,
      enabled: true
    }
  }, filteredIdList.map((thingPDIDDevice, index) => /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
    key: thingPDIDDevice,
    virtualIndex: index
  }, /*#__PURE__*/_react.default.createElement(_DeviceCard.DeviceCard, {
    key: thingPDIDDevice,
    thingPDIDDevice: thingPDIDDevice,
    inSwiper: true
  }))));
};
exports.DeviceSwiper = DeviceSwiper;